.filterItem {
  flex: 1 1 220px;
  min-width: 220px;
}

.filterItem :global(.ant-picker) {
  width: 100%;
}

.peopleCard {
  flex: 1 1 280px;
  min-width: 0;
}
